import {observer} from 'mobx-react';
import React from 'react';
import {action} from 'mobx';
import * as util from '../../../util';

type Props = {
    id: string;
    ariaLabel: string;
    styleBlack?: boolean;
    useMargin?: boolean;
};

@observer
class InfoIcon extends React.Component<Props> {
    @action
    click(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) {
        e.preventDefault();
        e.stopPropagation();
        util.modal(this.props.id);
    }

    render() {
        const {id, ariaLabel, useMargin, styleBlack} = this.props;

        return (
            <button
                type="button"
                className="info-button"
                aria-haspopup="dialog"
                aria-controls={id}
                aria-label={ariaLabel}
                style={{marginLeft: useMargin ? 5 : ''}}
                onClick={e => this.click(e)}
            >
                <i
                    className="far fa-info-circle"
                    style={{color: styleBlack ? '#222' : ''}}
                />
            </button>
        );
    }
}

export default InfoIcon;
